import React from 'react'
import useMemberTable from '../context/MemberTableContext'
import Button from '../../../../common/button/Button'
import { handleMembersConfirmationModal } from './Utils'

const MembersTableButton = ({ id, info, hasModal = null, btnName = '', btnClassName = '', btnDisabled = '', teamType = 'wooteams' }) => {

  const { setSelectedUser, setSelectedModal } = useMemberTable()

  return(
    <Button
      className={`msync-button--is-size-sm ${btnClassName ? btnClassName : 'msync-button--is-theme-secondary msync-button--is-style-outline'}`}
      onClick={ () => handleMembersConfirmationModal( id, info, hasModal, setSelectedUser, setSelectedModal, teamType ) }
      isDisabled={ btnDisabled ? btnDisabled : '' }
    >
      { btnName ? btnName : 'Open Modal' }
    </Button>
  )
  
}

export default MembersTableButton
